import { Divider } from "@mui/material";
import React from "react";

export function withDivider<T>(Component: React.ComponentType<T>) {
  return (props: T & { showDivider?: boolean, items: any[], index: number }) => (
    <>
      <Component {...props} />
      {props.index < props.items.length - 1 && <Divider />}
    </>
  );
}
